$("body").on("click", ".ajax-atc", function(e){
  e.preventDefault();
  $(this).addClass("processing");
  var variantId = $(this).attr("data-variant-id");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      "quantity": 1,
      "id": variantId
    },
    success: function (cart) {
      openDrawer();
      $(".ajax-atc").removeClass("processing");
    }
  });
})
$("body").on("click", ".close_cart", function(){
  $(".slidecart-overlay").removeClass("open");
  $(".slidecart").removeClass("open");
});

$("body").on("click", ".site-header-cart--button", function(e){
  e.preventDefault();
  openDrawer();
});
$("body").on("click", ".js-qty__adjust", function () {
  var productId = parseInt($(this).attr("data-id"));
  var currentQty = parseInt($("#updates_"+productId).val());
  if($(this).hasClass("up")){
    currentQty = currentQty+1;
  }
  else{
    currentQty = currentQty-1;
  }
  $("#updates_"+productId).val(currentQty);
  updateCart(productId, currentQty);
});
$("body").on("blur", ".js-qty__num", function () {
  var productQty = parseInt($(this).val());
  var productId = parseInt($(this).attr("data-id"));
  updateCart(productId, productQty);
})
function updateCart(productId, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {quantity:qty, id:productId},
    dataType: 'json',
    success: function(cart) {
      openDrawer()
    }
  });
}
$("body").on("click", ".remove", function(){
  var productQty = parseInt(0);
  var productId = parseInt($(this).attr("data-id"));
  updateCart(productId, productQty);
})
function openDrawer(){
  $.ajax({
    type: 'GET',
    url: '/cart?view=drawer',
    async: false,
    success: function (cart) {
      $(".slidecart").html('');
      $(".slidecart").html(cart);
      $(".site-header-cart--count").attr("data-header-cart-count", $(".cart-count").text());
      $(".slidecart-overlay").addClass("open");
      $(".slidecart").addClass("open");
      setTimeout(function(){
        $('.upsell_slider').slick({
          lazyLoad: 'ondemand',
          arrows: true,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          infinite: true,
          cssEase: 'linear'
        });
        $(".upsells").show();
      },1000);
    }
  });
}
$('body').on("click", "#slidecart-agree" ,function(){
  if($(this).prop("checked") == true){
    $(".checkout_btn").attr("disabled", false);
  }
  else if($(this).prop("checked") == false){
    $(".checkout_btn").attr("disabled", true);
  }
});
$("body").on("click", ".product-form--atc-button", function(e){
  e.preventDefault();
 var variantId = '';
  variantId = parseInt($(".variants-ui__select-main").val());
  if(!variantId){
  	variantId = parseInt($(".variants-ui--default-variant").val());
  }
  
  
  $(this).addClass("processing");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      "quantity": 1,
      "id": variantId
    },
    success: function (cart) {
      openDrawer();
      $(".product-form--atc-button").removeClass("processing");
    }
  });
});
$(document).on('keydown', function(event) {
  if (event.key == "Escape") {
    $(".slidecart-overlay").removeClass("open");
    $(".slidecart").removeClass("open");
  }
});
$(window).on('load', function(){
  if (window.location.href.indexOf("#cart") > -1) {
    openDrawer();
  }
});